import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 48 48"
            enableBackground="new 0 0 48 48"
            xmlSpace="preserve"
        >
            <polyline
                points="13.5,3 34.5,24 13.5,45 "
                strokeMiterlimit="10"
                strokeWidth="1.75"
                fill="transparent"
                stroke="#b3b3b3"
            />
        </svg>
    );
};

export default React.memo(ChevronRight);
